import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { Fabrictype } from './fabrictype';

import { Configuration } from '../../../app.constants';
import { AuthenticationService } from '../../../shared/services/authentication.service';

@Injectable()
export class FabrictypeService {

  private _apiUrl: string = this._configuration.apiUrl + '/v2/fabrictypes';
  //private _apiQuantityUnitsUrl: string = this._configuration.apiUrl + '/v2/fabrictypeQuantityUnits';
  //private _apiWeightUnitsUrl: string = this._configuration.apiUrl + '/v2/fabrictypeWeightUnits';

  private headers: Headers;

  constructor(
    private _http: Http,
    private _configuration: Configuration,
    public _authService: AuthenticationService) { }


  getFabrictypes(): Observable<Fabrictype[]> {
    let h: Headers = this._authService.getHeaders();

    return this._http.get(this._apiUrl, { headers: h, search: undefined }).map(
      (response: any) => {

        let body: any = response.json();
        if (body.fabrictypes && Array.isArray(body.fabrictypes)) {
          return body.fabrictypes;
        } else {
          return [];
        }

      }
    );
  }

  createFabricType(fType: Fabrictype): Observable<any> {
    let h: Headers = this._authService.getHeaders();

    return this._http.post(this._apiUrl, fType, { headers: h, search: null }).map(response=>response.json());
  }

  updateFabricType(id: string, fType: Fabrictype): Observable<any> {
    let h: Headers = this._authService.getHeaders();

    return this._http.put(this._apiUrl, fType, { headers: h, search: {id: id} }).map(response=>response.json());
  }
// Since we're hard-coding the units, there's no need to keep functions to create them
/*  addQuantityUnit(id: string, unit: Unit): Observable<any> {
    let h: Headers = this._authService.getHeaders();

    return this._http.post(this._apiQuantityUnitsUrl, unit, { headers: h, search: { fabric_type_id: id } }).map(response=>response.json());
  }

  addWeightUnit(id: string, unit: Unit): Observable<any> {
    let h: Headers = this._authService.getHeaders();

    return this._http.post(this._apiWeightUnitsUrl, unit, { headers: h, search: { fabric_type_id: id } }).map(response=>response.json());
  }

  removeQuantityUnit(id: string): Observable<any> {
    let h: Headers = this._authService.getHeaders();

    return this._http.delete(this._apiQuantityUnitsUrl, { headers: h, search: { id: id } }).map(response=>response.json());
  }

  removeWeightUnit(id: string): Observable<any> {
    let h: Headers = this._authService.getHeaders();

    return this._http.delete(this._apiWeightUnitsUrl, { headers: h, search: { id: id } }).map(response=>response.json());
  }
*/

  /*getQuantityUnits(id: string): Observable<Unit[]> {
    let h: Headers = this._authService.getHeaders();

    return Observable.of(
      [{
        'id': '1',
        'name': 'Centimeters',
        'multiplier': 1,
        'symbol': 'cm'
      }, {
        'id': '2',
        'name': 'Inches',
        'multiplier': 0.393701,
        'symbol': 'in'
      }]
    );
  }*/

  /*getWeightUnits(id: string): Observable<Unit[]> {
    let h: Headers = this._authService.getHeaders();

    return Observable.of(
      [{
        'id': '1',
        'name': 'Grams',
        'multiplier': 1,
        'symbol': 'g'
      }, {
        'id': '2',
        'name': 'Kilograms',
        'multiplier': 1000,
        'symbol': 'kg'
      }]
    );
  }*/

  getOneFabricType(id: string): Observable<Fabrictype> {
    let h: Headers = this._authService.getHeaders();

    return this._http.get(this._apiUrl, { headers: h, search: { id: id } }).map(
      (response: any) => {
        return response.json();
      }
    );

    /*return Observable.of(
      {
        'id': '1',
        'name': 'Clothing Fabric',
        'quantity_units': [],
        'weight_units': [],
        'quantity_units_string': 'cm, in',
        'weight_units_string': 'g, kg',
        'active': true,
        'default': true
      }
    );*/

  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/purchasing/fabrictypes/fabrictype.service.ts